import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';
@Injectable({
  providedIn: 'root',
})
export class consultarHistoricoUsuariosIfService {
  url: string = environment.apiLocalUrl;

  constructor(private http: HttpClient) {}

  urlparametros: string = `${this.url}parametros/servicios`;

  getTipoDocumentos() {
    return this.http.get(`${this.urlparametros}/tipoDocIdentidad`).pipe(catchError(HandleHttpError));
  }

  //Consulta historial
  getModificarHistorial(body:any) {
    return this.http.post(this.url +'comun/servicios/historicoUsuario', body).pipe(catchError(HandleHttpError));
  }

  getConsultarHistorial(body:any) {
    return this.http.post(this.url + 'bancoldex/servicios/administracion/usuario/bloqueado', body).pipe(catchError(HandleHttpError));
  }

  dowloadConsultaHistoricosUsuarios(body:any){
    return this.http.post(`${this.url}bancoldex/servicios/administracion/historicoUsuarios/exportar`, body).pipe(catchError(HandleHttpError));
  } 
}